import Button from "@mui/joy/Button";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Sheet from "@mui/joy/Sheet";
import { Box } from "@mui/material";
import { type FC } from "react";

type TDeleteConfirmationModalProps = {
	open: boolean;
	title: string;
	message: string;
	confirmText?: string;
	loading?: boolean;
	className?: string;
	showCloseButton?: boolean;
	handleClose: () => void;
	confirmDelete: () => void;
};

export const DeleteConfirmationModal: FC<
	TDeleteConfirmationModalProps
> = ({
	open,
	title,
	message,
	confirmText = "Delete",
	loading = false,
	className,
	showCloseButton = false,
	handleClose,
	confirmDelete,
}) => {
	return (
		<Modal
			aria-labelledby="modal-title"
			aria-describedby="modal-desc"
			open={open}
			onClose={handleClose}
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<Sheet
				className={`reset-modal${className ? ` ${className}` : ""}`}
				variant="outlined"
				sx={{
					maxWidth: 500,
					borderRadius: "md",
					p: 3,
					boxShadow: "lg",
				}}
			>
				{showCloseButton && (
					<ModalClose
						aria-label="Close delete confirmation"
						disabled={loading}
						variant="plain"
						sx={{ m: 1 }}
					/>
				)}
				<h4 className={"title"}>{title}</h4>
				<p className={"content"}>{message}</p>
				<Box className={"btn-group"}>
					<Button
						className={"btn-type-tertiary"}
						onClick={handleClose}
						disabled={loading}
					>
						Cancel
					</Button>
					<Button
						className={"btn-type-secondary"}
						onClick={confirmDelete}
						disabled={loading}
						loading={loading}
					>
						{confirmText}
					</Button>
				</Box>
			</Sheet>
		</Modal>
	);
};

